import React, { Component } from 'react';
import axios from 'axios';
import { Container, Dimmer, Icon, Table, Button, Header, Modal, Input } from 'semantic-ui-react';
import { PtInputConditionTab } from '../../../../grit-utilities';
import ScrollArea from 'react-scrollbar';
import DropdownLib from '../../../../DropdownLib';
import config from '../../../../config';

export default class Traffic extends Component {

    constructor(props) {
        super(props);
        this.state = {
            ...this.props.trafficModel.pavementcondition,
            modalEditOn: false,
            doesSumToHund: false,
            saveButtonEnabled: false,
            tire6Su: '',
            ax3Su: '',
            ax3Tst: '',
            ax4Tst: '',
            ax5Tst: '',
            trBuses: '',
            twinTrailers: '',
            sum: 0.00,
            needsSave: false,
            truckAADT: 0.0,
            truckAadt20Year: 0.0,
            esals: 0.0,
            aadt20year: 0.0,
            esals20year: 0.0,
            year20: 0,
            cumEsals: 0.0,
            loadingModalOpen: false
        };
    }
    
    render() {
        /* delete later probably if still not needed 06/08/2021
        const { typeOptions,
            bridgeTypeOptions,
            rehabTypeOptions,
            maintTypeOptions,
            safetyTypeOptions,
            emergencyTypeOptions,
            projStatusOptions } = DropdownLib.getDropdowns().CP_ProjectInfo;

        const { RQITypeOptions, SRTypeOptions, RUTTypeOptions } = DropdownLib.getDropdowns().CSF_Condition;*/
        const ModalContentTable = (
            <Table celled structured compact="very">
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell rowSpan='2'  textAlign='center'>Vehicle Type</Table.HeaderCell>
                        <Table.HeaderCell rowSpan='2'  textAlign='center'>Vehicle Class %</Table.HeaderCell>
                        <Table.HeaderCell colSpan='2' textAlign='center'>ESAL Factors</Table.HeaderCell>
                    </Table.Row>
                    <Table.Row>
                        <Table.HeaderCell textAlign='center'>Flexible</Table.HeaderCell>
                        <Table.HeaderCell textAlign='center'>Rigid</Table.HeaderCell>
                        
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    <Table.Row>
                        <Table.Cell textAlign='center'>2AX-6TIRE SU</Table.Cell>
                        <Table.Cell textAlign='center' colSpan='1'>
                            <Input onChange={this.filterNumberInputOnchange} value={this.state.tire6Su} name="tire6Su" disabled={!this.state.modalEditOn} />
                        </Table.Cell>
                        <Table.Cell textAlign='center'>
                           0.25
                        </Table.Cell>
                        <Table.Cell textAlign='center'>
                           0.24
                        </Table.Cell>
                        
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell textAlign='center'>3AX+SU</Table.Cell>
                        <Table.Cell textAlign='center' colSpan='1'>
                            <Input name="ax3Su" onChange={this.filterNumberInputOnchange} value={this.state.ax3Su} disabled={!this.state.modalEditOn} />
                        </Table.Cell>
                        <Table.Cell textAlign='center'>
                            0.58
                        </Table.Cell>
                        <Table.Cell textAlign='center'>
                            0.85
                        </Table.Cell>
                        
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell textAlign='center'>3AX TST</Table.Cell>
                        
                        <Table.Cell textAlign='center' colSpan='1'>
                            <Input name="ax3Tst" onChange={this.filterNumberInputOnchange} value={this.state.ax3Tst} disabled={!this.state.modalEditOn} />
                        </Table.Cell>
                        <Table.Cell textAlign='center'>
                            0.39
                        </Table.Cell>
                        <Table.Cell textAlign='center'>
                            0.37
                        </Table.Cell>
                        
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell name="ax4Tst" textAlign='center'>4AX TST</Table.Cell>

                        <Table.Cell textAlign='center' colSpan='1'>
                            <Input onChange={this.filterNumberInputOnchange} name="ax4Tst" value={this.state.ax4Tst} disabled={!this.state.modalEditOn} />
                        </Table.Cell>
                        <Table.Cell textAlign='center'>
                            0.51
                        </Table.Cell>
                        <Table.Cell textAlign='center'>
                            0.53
                        </Table.Cell>

                    </Table.Row>
                    <Table.Row>
                        <Table.Cell textAlign='center'>5AX+TST</Table.Cell>

                        <Table.Cell textAlign='center' colSpan='1'>
                            <Input name="ax5Tst" onChange={this.filterNumberInputOnchange} value={this.state.ax5Tst} disabled={!this.state.modalEditOn} />
                        </Table.Cell>
                        <Table.Cell textAlign='center'>
                            1.13
                        </Table.Cell>
                        <Table.Cell textAlign='center'>
                            1.89
                        </Table.Cell>

                    </Table.Row>
                    <Table.Row>
                        <Table.Cell textAlign='center'>TR TR, BUSES</Table.Cell>

                        <Table.Cell textAlign='center' colSpan='1'>
                            <Input name="trBuses" onChange={this.filterNumberInputOnchange} value={this.state.trBuses} disabled={!this.state.modalEditOn} />
                        </Table.Cell>
                        <Table.Cell textAlign='center'>
                            0.57
                        </Table.Cell>
                        <Table.Cell textAlign='center'>
                            0.74
                        </Table.Cell>

                    </Table.Row>
                    <Table.Row>
                        <Table.Cell textAlign='center'>TWIN TRAILERS</Table.Cell>

                        <Table.Cell textAlign='center' colSpan='1'>
                            <Input name="twinTrailers" onChange={this.filterNumberInputOnchange} value={this.state.twinTrailers} disabled={!this.state.modalEditOn} />
                        </Table.Cell>
                        <Table.Cell textAlign='center'>
                            2.40
                        </Table.Cell>
                        <Table.Cell textAlign='center'>
                            2.33
                        </Table.Cell>

                    </Table.Row>
                </Table.Body>
                <Table.Footer>
                    <Table.Row>
                        <Table.HeaderCell textAlign='center'>Total</Table.HeaderCell>

                        <Table.HeaderCell colSpan='1' textAlign='center'>
                            {this.state.sum}
                        </Table.HeaderCell>
                        <Table.HeaderCell textAlign='center'>
                            NA
                        </Table.HeaderCell>
                        <Table.HeaderCell textAlign='center'>
                            NA
                        </Table.HeaderCell>

                    </Table.Row>
                </Table.Footer>
            </Table>
        );
        const VehicleClassModal = (
            <div>
                <div>
                    <Modal closeOnEscape={true} onClose={() => this.setState({ modalEditOn: false, needsSave: false })} closeOnDimmerClick={false} closeIcon={true} size="mini" centered={false} trigger={<Button>Vehicle Class %</Button>}>
                        <Modal.Header>Vehicle Class %</Modal.Header>
                        <Modal.Content>

                            <Modal.Description>

                                {ModalContentTable}
                            </Modal.Description>
                        </Modal.Content>
                        <Modal.Actions>
                            <Button color='blue' onClick={() => this.setState({ modalEditOn: true })}>
                                Edit
                    </Button>
                            <Button
                                positive
                                icon='checkmark'
                                labelPosition='right'
                                disabled={!(this.state.saveButtonEnabled && this.state.needsSave)}
                                content="Save"
                                onClick={this.overrideTrafficPctValues}
                            />
                        </Modal.Actions>
                    </Modal>
                </div>
                <Dimmer.Dimmable dimmed={this.state.loadingModalOpen}>
                    <Dimmer page active={this.state.loadingModalOpen}>
                        <Header as='h2' icon inverted>
                            <Icon loading name='spinner' />
                        Loading...
                    <Header.Subheader>This may take a few seconds.</Header.Subheader>
                        </Header>
                    </Dimmer>
                </Dimmer.Dimmable>
            </div>
        );
        return (
            <Container>
                <ScrollArea
                    speed={1}
                    className={!window.mobileAndTabletcheck() ? "area_desktop" : "area_mobile"}
                    contentClassName="content"
                    smoothScrolling={true}>

                    <Table compact="very">
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell>AADT</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell><PtInputConditionTab whichInput="firsttb" inputType="hwy" name="AADT" disabled value={this.state.AADT === null ? "" : this.state.AADT} placeholder="Not Available"
                                /></Table.Cell>
                                <Table.Cell ><PtInputConditionTab whichInput="secondttb" disabled={this.props.disabled} inputType="number" name="AADTOver" value={!this.state.AADTOver ? '' : this.state.AADTOver} placeholder="override"
                                    onChange={this.onInputChange} /></Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Truck AADT</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell ><PtInputConditionTab whichInput="firsttb" inputType="hwy" value={this.state.truckAADT} name="truckAADT" disabled /></Table.Cell>
                                <Table.Cell>{VehicleClassModal}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>ESALs</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell ><PtInputConditionTab whichInput="firsttb" inputType="hwy" name="ESALs" disabled value={this.state.esals} /></Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell >Year</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell ><PtInputConditionTab whichInput="firsttb" inputType="year" name="TrafficYear" disabled 
                                    value={this.state.TrafficYear === 0 ? '' : this.state.TrafficYear} placeholder="1900"/>
                                </Table.Cell>
                                <Table.Cell ><PtInputConditionTab whichInput="secondttb" disabled={this.props.disabled} inputType="year" name="YearOver" 
                                    value={this.state.YearOver === 0 ? '': this.state.YearOver} placeholder="Override"onChange={this.onInputChange} />
                                </Table.Cell>     
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Projection Factor(%)</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell ><PtInputConditionTab whichInput="firsttb" inputType="hwy" name="GrowthFactor" disabled value={this.state.GrowthFactor == null ? "Not Available" : `${Math.round(this.state.GrowthFactor * 100*100)/100}%`} /></Table.Cell>
                                <Table.Cell ><PtInputConditionTab whichInput="secondttb" disabled={this.props.disabled} name="GrowthFactorOver" value={!this.state.GrowthFactorOver ? '' : this.state.GrowthFactorOver} placeholder="Override" onChange={this.filterDecimalForGrowthFactor} /></Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell  >AADT- 20 Year</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell ><PtInputConditionTab whichInput="firsttb" inputType="hwy" value={this.state.aadt20year} name="AADT20Year" disabled /></Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell  >Truck AADT - 20 Year</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell ><PtInputConditionTab whichInput="firsttb" inputType="hwy" value={this.state.truckAadt20Year} name="TruckAADT20Year" disabled /></Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>ESALs - 20 Year</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell ><PtInputConditionTab value={this.state.esals20year} whichInput="firsttb" inputType="hwy" name="ESALs20Year" disabled /></Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Year - 20 Year</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell ><PtInputConditionTab whichInput="firsttb" value={this.state.year20} inputType="hwy" name="Year20Year" disabled /></Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Cumulative ESALs - 20 Year</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell ><PtInputConditionTab whichInput="firsttb" value={this.state.cumEsals} inputType="hwy" name="CumulativeEsals20Year" disabled /></Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                </ScrollArea>
            </Container>
            );
    }

    handleLoadingOpen = (val) => this.setState({ loadingModalOpen: val })

    onInputChange = (e) => {
        const { name, value } = e.target;
        this.props.triggerNeedSave();

        this.setState({ [name]: value === '' ? null : value });
    }
    onChangeSRnRqiDropdown = (e) => {
        const { target } = e;
        const { name, value } = target;
        this.props.triggerNeedSave();
        // eslint-disable-next-line
        this.setState({ [name]: parseInt(value) }, () => {
            const { RQITypeOptions, SRTypeOptions, } = DropdownLib.getDropdowns().CSF_Condition;
            this.setState({ PQIOver: (this.state.SROver !== 0 && this.state.RQIOver !== 0) ? Math.sqrt(RQITypeOptions[this.state.SROver].label * SRTypeOptions[this.state.RQIOver].label).toFixed(2) : null });
        });


    }
    onChangeDropdown = (e) => {
        const { target } = e;
        const { name, value } = target;
        this.props.triggerNeedSave();
        this.setState({ [name]: value === '' ? null : parseFloat(value) });
    }

    onChangeDate = (date, name) => {
        this.props.triggerNeedSave();
        this.setState({ [name]: `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}` });
    }

    //for yearoverride fetch function
    fetchyearOverride = () =>{
         fetch(`${config.server}/yearoverride/`+this.props.trafficModel.route.id).then(response=>response.json()).then(data=>{
             if (data.length !== 0)
             this.setState({YearOver: data[0].YearOver});
             else
             this.setState({YearOver: 0});
         })
    }

    //for modal
    fetchTrafficPctValues = () => {
        axios.get(`${config.server}\\getTruckpctdata\\${this.props.trafficModel.route.id}\\${this.props.trafficModel.lpModel.lastProjectSurf}`)
            .then((res) => {
                console.log(res.data);
                this.setState({
                    tire6Su: Math.round(res.data.data.tire6Su*100*100)/100,
                    ax3Su: Math.round(res.data.data.ax3Su * 100 * 100) / 100,
                    ax3Tst: Math.round(res.data.data.ax3Tst * 100 * 100) / 100,
                    ax4Tst: Math.round(res.data.data.ax4Tst * 100 * 100) / 100,
                    ax5Tst: Math.round(res.data.data.ax5Tst * 100 * 100)/100,
                    trBuses: Math.round(res.data.data.trBuses * 100 * 100)/100,
                    twinTrailers: Math.round(res.data.data.twinTrailers * 100 * 100) / 100,
                    AADT: res.data.AADTs.AADT,
                    AADTOver: res.data.AADTs.AADTOver,
                    truckAADT: Math.round(res.data.AADTs.TruckAadt),
                    esals: Math.round(res.data.ESALs.ESAL),
                    aadt20year: Math.round(res.data.AADTs.Aadt20Year),
                    truckAadt20Year: Math.round(res.data.AADTs.TruckAadt20year),
                    esals20year: Math.round(res.data.ESALs.Esal20Year),
                    cumEsals: Math.round(res.data.ESALs.CumEsal20Year),
                    year20: res.data.Year.Year20,
                    GrowthFactor: res.data.Growth.GrowthFactor ? this.limitGrowthFactor(res.data.Growth.GrowthFactor) : null,
                    GrowthFactorOver: res.data.Growth.GrowthFactorOver ? res.data.Growth.GrowthFactorOver * 100 : null,
                    TrafficYear: res.data.Year.AadtYear
                }, () => {
                    let total = this.state.tire6Su + this.state.ax3Su + this.state.ax3Tst + this.state.ax4Tst + this.state.ax5Tst + this.state.trBuses + this.state.twinTrailers;
                    this.setState({ sum: `${total}%` });
                })
            }).catch((err) => {
                console.log('Could not connect to server');
            })
    }

    overrideTrafficPctValues = () => {
        this.handleLoadingOpen(true);
        console.log('Save button is clicked. handleLoadingOpen: ' + this.state.loadingModalOpen);
        let data = {
            tire6Su: parseFloat(this.state.tire6Su)/100,
            ax3Su: parseFloat(this.state.ax3Su)/100,
            ax3Tst: parseFloat(this.state.ax3Tst)/100,
            ax4Tst: parseFloat(this.state.ax4Tst)/100,
            ax5Tst: parseFloat(this.state.ax5Tst)/100,
            trBuses: parseFloat(this.state.trBuses)/100,
            twinTrailers: parseFloat(this.state.twinTrailers)/100
        }
        axios.post(`${config.server}\\updateorinserttruckpctdata\\${this.props.trafficModel.route.id}`, data)
            .then((res) => {
                console.log(res.data);
                this.setState({ saveButtonEnabled: false });
                this.fetchTrafficPctValues();
                this.handleLoadingOpen(false);
            })
    }

    limitGrowthFactor = (val) => {
        //let temp = Math.round(val*1000)/1000
        if (!val) {
            return null;
        }
        else if ((Math.round(val * 1000) / 1000) < 0.005) {
            return 0.005;
        }
        else if ((Math.round(val * 1000) / 1000) > 0.1) {
            return 0.1;
        }
        else return Math.round(val * 1000) / 1000;
    }

    filterDecimalForGrowthFactor = (e) => {
        
        const { name, value } = e.target;
        const regex = new RegExp('^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$');
        if (value === '' || regex.test(value)) {
            this.setState({ [name]: value });
            console.log('i am here ' + value);
            this.props.triggerNeedSave();
            
        }
    }

    filterNumberInputOnchange = (e) => {
        const { name, value } = e.target;
        const regex = new RegExp('^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$');
        if (value === '' || regex.test(value)) {
            this.setState({ [name]: value, needsSave: true }, () => {
                let total = parseFloat(this.state.tire6Su) + parseFloat(this.state.ax3Su) + parseFloat(this.state.ax3Tst) + parseFloat(this.state.ax4Tst) + parseFloat(this.state.ax5Tst) + parseFloat(this.state.trBuses) + parseFloat(this.state.twinTrailers);
                if (!isNaN(total)) {
                    this.setState(
                        {
                            sum: `${total}%`,
                            saveButtonEnabled: true
                        })
                }
                else {
                    this.setState({ sum: 'Make sure all are numbers!', saveButtonEnabled: false });
                }
            });
        }
    }

    componentDidMount() {
        this.fetchTrafficPctValues();
        this.fetchyearOverride();
    }

    componentDidUpdate() {
        this.props.trafficModel.pavementcondition = this.state;
    }
}


// WEBPACK FOOTER //
// ./src/layers/tabs/cons-segment/forecasting/traffic.js